import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';
import { useLocation } from 'react-router-dom';
import BVReviews from 'components/consumer/PDP/BazaarVoice/BVReviews';
import useBvReviewsForceMount from 'components/consumer/PDP/BazaarVoice/useBvReviewsForceMount';
import usePdpFullVariantSku from '../state/pdpFullVariantSku/usePdpFullVariantSku';
const PDPCustomerPhotos = () => {
  const $ = _c(11);
  const variantSku = usePdpFullVariantSku();
  const containerRef = useRef(null);
  const forceMountReviews = useBvReviewsForceMount();
  const location = useLocation();
  const [hasMounted, setHasMounted] = useState(false);
  const pdpIdentity = `${variantSku}:${location.pathname}`;
  const [mountedIdentity, setMountedIdentity] = useState(pdpIdentity);
  if (mountedIdentity !== pdpIdentity) {
    setMountedIdentity(pdpIdentity);
    setHasMounted(false);
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      rootMargin: "600px 0px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const intersection = useIntersection(containerRef, t0);
  const hasApproachedViewport = intersection?.isIntersecting;
  const shouldMountReviews = hasApproachedViewport || forceMountReviews;
  let t1;
  let t2;
  if ($[1] !== hasMounted || $[2] !== shouldMountReviews) {
    t1 = () => {
      if (hasMounted) {
        return;
      }
      if (shouldMountReviews) {
        setHasMounted(true);
      }
    };
    t2 = [shouldMountReviews, hasMounted];
    $[1] = hasMounted;
    $[2] = shouldMountReviews;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== hasMounted || $[6] !== shouldMountReviews || $[7] !== variantSku) {
    t3 = (hasMounted || shouldMountReviews) && <BVReviews key={variantSku} productId={variantSku} />;
    $[5] = hasMounted;
    $[6] = shouldMountReviews;
    $[7] = variantSku;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div ref={containerRef} className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 min-h-[400px]" id="PDPCustomerPhotos">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default PDPCustomerPhotos;